import ActiveAlarms from "../components/configuration/Alarms/ActiveAlarms";

const AlarmsTablePage = () =>{
     
    return (
         <ActiveAlarms/>
    )
}

export default AlarmsTablePage;